function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJira48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.98031,
    y1: 0.00161,
    x2: 0.58888,
    y2: 0.40766,
    gradientTransform: "matrix(22.429688,0,0,21.832031,12.789062,15.105469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(0%,32.156863%,80%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.901961%,51.764706%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 1.00665,
    y1: 0.00455,
    x2: 0.55402,
    y2: 0.44727,
    gradientTransform: "matrix(22.429688,0,0,21.832031,2.570313,25.167969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(0%,32.156863%,80%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.901961%,51.764706%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,51.764706%,100%)",
      fillOpacity: 1
    },
    d: "M 43.640625 5.035156 L 23 5.035156 C 23 10.074219 27.171875 14.15625 32.316406 14.15625 L 36.117188 14.15625 L 36.117188 17.75 C 36.121094 22.785156 40.289062 26.863281 45.429688 26.867188 L 45.429688 6.789062 C 45.429688 5.820312 44.628906 5.035156 43.640625 5.035156 Z M 43.640625 5.035156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 33.425781 15.105469 L 12.789062 15.105469 C 12.792969 20.136719 16.957031 24.21875 22.097656 24.21875 L 25.902344 24.21875 L 25.902344 27.824219 C 25.90625 32.859375 30.078125 36.9375 35.21875 36.9375 L 35.21875 16.855469 C 35.21875 15.890625 34.414062 15.105469 33.425781 15.105469 Z M 33.425781 15.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 23.210938 25.167969 L 2.570312 25.167969 C 2.570312 30.207031 6.742188 34.289062 11.886719 34.289062 L 15.699219 34.289062 L 15.699219 37.882812 C 15.703125 42.914062 19.863281 46.992188 25 47 L 25 26.921875 C 25 25.953125 24.199219 25.167969 23.210938 25.167969 Z M 23.210938 25.167969 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira48);
export default __webpack_public_path__ + "static/media/jira-48.d97c1bb31dd374a21a574034f0ea4a50.svg";
export { ForwardRef as ReactComponent };